var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-block",class:{'invalid-feedback': !_vm.challenge.passed, 'valid-feedback': _vm.challenge.passed}},[_vm._v(" "+_vm._s(_vm.challenge.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }